// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 8592 ? "common" : chunkId) + "." + {"8536":"a058dcfaa94d38d2","8592":"54caea2bdbe49f2a"}[chunkId] + ".css";
};